import { z } from 'zod';
import { TRANSPORT_EXCHANGE_VALUE } from '@/shared/constants/transportExchange.ts';

export type CarrierOrganizationIdSchemaParams = {
    excludedIds?: (number | typeof TRANSPORT_EXCHANGE_VALUE)[];
    errorMessages?: {
        required?: string;
    };
};

export function CarrierOrganizationIdSchema(params?: CarrierOrganizationIdSchemaParams) {
    const { excludedIds = [], errorMessages } = params ?? {};

    return z
        .union([
            z.number({ required_error: errorMessages?.required }).int().positive(),
            z.enum([TRANSPORT_EXCHANGE_VALUE], { message: errorMessages?.required }),
        ])
        .refine(value => !excludedIds.includes(value), {
            message: errorMessages?.required,
        });
}
